import React, { useState } from 'react';
import './style.css';
import Select from 'react-select';

const selectStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isDisabled ? 'var(--theme-less-light)' : 'var(--theme-light)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: state.isFocused || state.isHovered ? 'var(--theme-deep-blue)' : 'var(--theme-dark-accent)',
    minHeight: '32px',
    color: 'var(--theme-off-black)'
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    color: 'var(--theme-off-black)',
    borderColor: 'none',
    fontFamily: 'NeueMontreal',
    fontSize: '14px'
  }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    color: 'var(--theme-dark-accent)'
  }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: 'var(--theme-main-backgrond)',
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontSize: '14px',
    fontFamily: 'NeueMontreal',
    fontWeight: state.isSelected ? '700' : '400',
    color: state.isSelected ? 'var(--theme-red)' : 'var(--theme-off-black)',
    backgroundColor: state.isFocused ? 'var(--theme-less-light)' : 'var(--theme-main-background)',
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    background: 'var(--theme-less-light)',
    fontFamily: 'NeueMontreal',
    color: 'var(--theme-off-black)',
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    padding: '0px 8px'
  }),
  clearIndicator: (baseStyles) => ({
    ...baseStyles,
    padding: '0px 8px'
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    fontFamily: 'NeueMontreal',
    color: 'var(--theme-off-black)',
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    fontFamily: 'NeueMontreal',
    fontSize: '14px',
    color: 'var(--theme-off-black)',
  }),
}


export default function ReactSelectWrapper({ value, change, options, disabled, placeholder = '' }) {
  const [filteredOptions, setFilteredOptions] = useState(options.length > 1200 ? options.slice(0, 40) : options);

  const getValue = (v) => {
    return options.filter((option) => {
      return value === option.value;
    })
  }

  const handleInputChange = (inputValue) => {
    if (inputValue.length > 2 && options.length > 1200) {
      setFilteredOptions(
        options.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()) || option.label.toLowerCase().includes(inputValue.toLowerCase()))
      );
    } else if (options.length < 1200) {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(options.slice(0, 40));
    }
  };


  return (
    <Select
      value={getValue()}
      onChange={(v) => { change(!v ? '' : v.value); }}
      options={filteredOptions}
      styles={selectStyles}
      key={options.length}
      isDisabled={disabled}
      onInputChange={handleInputChange}
      placeholder={placeholder}
      isClearable={true}
    />
  )
}


export function ReactSelectMultiWrapper({ values, change, options, disabled, placeholder = '' }) {
  return (
    <Select
      value={values}
      onChange={(v) => { change(v); }}
      options={options}
      styles={selectStyles}
      isDisabled={disabled}
      placeholder={placeholder}
      isMulti={true}
    />
  )
}